const FormPropsContext = React.createContext(null);
export function FormPropsProvider({ disabled, readOnly, children }) {
    const formProps = useMemo(() => ({ readOnly, disabled }), [disabled, readOnly]);
    return (React.createElement(FormPropsContext.Provider, { value: formProps }, children));
}
export function useFormProps() {
    const formProps = React.useContext(FormPropsContext);
    return formProps;
}
